import { render, staticRenderFns } from "./converterNutritionalSolutions.html?vue&type=template&id=68cb4a8b&scoped=true&"
import script from "./converterNutritionalSolutions.js?vue&type=script&lang=js&"
export * from "./converterNutritionalSolutions.js?vue&type=script&lang=js&"
import style0 from "./converterNutritionalSolutions.scss?vue&type=style&index=0&id=68cb4a8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb4a8b",
  null
  
)

export default component.exports